module.exports = __webpack_public_path__ + "static/media/image1.b5831e7f.jpg";